(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  //customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-main"] && !window.DesignMode) return;
  try {
    
  class LocalizationFormHeader extends HTMLElement {
    constructor() {
      super();

      // Prevent multiple bindings
      if (this.dataset.initialized === "true") return;
      this.dataset.initialized = "true";

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        details: this.querySelector('details')
      };

      // Attach event listeners
      this.querySelectorAll('a').forEach((item) => {
        console.log('Item click attached'); // Debugging line
        item.addEventListener('click', this.onItemClick.bind(this));
      });

      if (this.elements.details) {
        this.elements.details.addEventListener('toggle', this.onToggle.bind(this));
      }
    }

    onItemClick(event) {
      console.log('Item clicked'); // Debugging line
      //event.preventDefault();

      const form = this.querySelector('form');
      const target = event.currentTarget;

      if (form && target.dataset.value) {
        this.elements.input.value = target.dataset.value;
        form.submit();
      }
    }

    onToggle() {
      console.log('Details toggled'); // Debugging line
      if (this.elements.details.open) {
        this.querySelector('ul').style.display = 'block';
      } else {
        this.querySelector('ul').style.display = 'none';
      }
    }
  }

  customElements.define('localization-form-header', LocalizationFormHeader);

  } catch(e) { console.error(e); }
})();
})();
